export default __webpack_public_path__ + "static/survey-templates-light-ba1fa20a8dd7f725b9f8e129472b6e53.png";